import type { ReactNode } from 'react';
import { VStack } from '@cbhq/cds-web/layout';

import type { LEProductAccessGroupParams } from './LEProductAccessGroup';
import { LEProductAccessGroup } from './LEProductAccessGroup';

export type MultiLEProductAccessGroupProps = {
  entities: LEProductAccessGroupParams[];
  footer?: ReactNode;
  defaultExpanded?: boolean;
  isEditable?: boolean;
  /** IDFE-3663 (t0018_74bfb564): render a divider above the workspace role row. */
  showWorkspaceRoleDivider?: boolean;
};

export function MultiLEProductAccessGroup({
  entities,
  footer,
  defaultExpanded,
  isEditable = true,
  showWorkspaceRoleDivider = false,
}: MultiLEProductAccessGroupProps) {
  return (
    <VStack gap={2} width="100%">
      {entities.map((entity) => (
        <LEProductAccessGroup
          key={entity.entityRow.entityId}
          {...entity}
          defaultExpanded={defaultExpanded ?? entity.defaultExpanded}
          isEditable={entity.isEditable ?? isEditable}
          showWorkspaceRoleDivider={entity.showWorkspaceRoleDivider ?? showWorkspaceRoleDivider}
        />
      ))}
      {footer}
    </VStack>
  );
}
